import { render, staticRenderFns } from "./ImageRef.vue?vue&type=template&id=384b8215&scoped=true&"
import script from "./ImageRef.vue?vue&type=script&lang=js&"
export * from "./ImageRef.vue?vue&type=script&lang=js&"
import style0 from "./ImageRef.vue?vue&type=style&index=0&id=384b8215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b8215",
  null
  
)

export default component.exports